// English translations
export const en = {
  // Header
  header: {
    excursions: 'Excursions',
    packages: 'Packages',
    howItWorks: 'How it works',
    reviews: 'Reviews',
    faq: 'FAQ',
    whatsapp: 'WhatsApp',
    chatOnWhatsapp: 'Chat on WhatsApp'
  },

  // Hero
  hero: {
    badge: 'Your local contact in Hurghada',
    title: 'Excursions in Hurghada',
    titleHighlight: 'in English',
    subtitle: 'Simple, reliable and stress-free',
    description: 'I\'m based in Hurghada, and I help you book tested and selected excursions with reliable partners.',
    cta: 'Chat on WhatsApp',
    ctaSubtext: 'Fast response guaranteed',
    features: {
      french: 'English support',
      selected: 'Selected activities',
      easy: 'Easy booking via WhatsApp'
    }
  },

  // Excursions Section
  excursions: {
    badge: 'Our activities',
    title: 'Most popular excursions',
    subtitle: 'Selected and tested experiences for you',
    viewDetails: 'View details',
    inquire: 'Inquire'
  },

  // Packages Section
  packages: {
    badge: 'Extended stays',
    title: 'Staying for several days?',
    titleHighlight: 'Our most popular packages',
    subtitle: 'Excursion combinations to make the most of your stay',
    included: 'INCLUDED:',
    bookNow: 'Book this pack',
    notSure: 'Not sure which pack is best for you?',
    askAdvice: 'Ask me on WhatsApp'
  },

  // How It Works
  howItWorks: {
    badge: 'Simple and fast',
    title: 'How does it work?',
    subtitle: '2 simple steps to book your excursion',
    steps: [
      {
        title: 'Message me on WhatsApp',
        description: 'Ask your questions and tell me what interests you'
      },
      {
        title: 'You receive everything',
        description: 'Schedules, meeting points and practical info for each activity'
      }
    ]
  },

  // Testimonials
  testimonials: {
    badge: 'Testimonials',
    title: 'What our travelers say',
    subtitle: 'Authentic reviews from real customers'
  },

  // FAQ
  faq: {
    badge: 'Need help?',
    title: 'Frequently asked questions',
    subtitle: 'Everything you need to know before booking',
    moreQuestions: 'Have more questions? I\'m here to help.',
    askQuestion: 'Ask me your question'
  },

  // Footer
  footer: {
    description: 'Your local contact in Hurghada for simple, reliable and stress-free excursions.',
    quickLinks: 'Quick links',
    contact: 'Contact',
    contactText: 'Available every day on WhatsApp',
    chatNow: 'Chat now',
    copyright: '© 2025 Hurghada Excursions. All rights reserved.',
    madeWith: 'Website made with'
  },

  // Final CTA
  finalCta: {
    title: 'Ready for an unforgettable experience?',
    subtitle: 'Contact me on WhatsApp to organize your excursion.',
    cta: 'Chat on WhatsApp'
  },

  // Activity Page
  activity: {
    backToMenu: 'Back to menu',
    home: 'Home',
    perPerson: '/ person',
    bookDeposit: 'Book – secure deposit',
    securePayment: 'Secure payment · Deposit only · Immediate confirmation',
    depositNote: 'Deposit amount may vary depending on activity and date. Balance to be paid on site on the day of the excursion.',
    needHelp: 'Need help? WhatsApp',
    duration: 'Duration',
    departure: 'Departure',
    departureTime: 'Departure time',
    return: 'Return',
    itinerary: 'Day schedule',
    included: 'Included',
    notIncluded: 'Not included',
    question: 'Any questions?',
    questionSubtext: 'I respond quickly on WhatsApp.',
    trustFrench: 'English support',
    trustFrenchDesc: 'I assist you in English',
    trustPartners: 'Local partners',
    trustPartnersDesc: 'Selected and tested',
    trustPayment: 'Secure payment',
    trustPaymentDesc: 'Stripe deposit + balance on site',
    packsBadge: 'Save with our packs',
    packsTitle: 'Staying for several days?',
    packsSubtitle: 'Discover our excursion packs and enjoy great rates.',
    viewPacks: 'View packs',
    faqTitle: 'Frequently asked questions',
    readyToBook: 'Ready to book?',
    readyToBookSubtitle: 'Confirm your spot with a secure deposit.',
    availableDays: 'Available days',
    option: 'Option'
  },

  // Packs Page
  packs: {
    title: 'Our Excursion Packages',
    subtitle: 'Combine multiple excursions and save',
    backToHome: 'Back to home',
    depositFrom: 'Deposit:',
    remaining: 'Balance on site:',
    book: 'Book this pack'
  },

  // Common
  common: {
    learnMore: 'Learn more',
    bookNow: 'Book now',
    contact: 'Contact'
  }
};

export default en;
